import { useParams } from "react-router-dom";
import { useState } from "react";
import GenericActionBar from "../../../Layouts/GenericActionBar/GenericActionBar";
import Input from "../../../components/FormComponents/Input";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import Textarea from "../../../components/FormComponents/Textarea";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import { toastError, toastSuccess } from "../../../utils/toastUtils";
import { saveFile } from "../../../commonFunctions/fileFolderConfig";
import useDirtyChecker from "../../../hooks/useDirtyChecker";

const GoogleDocTemplateEditor = ({ file, templateData, setTemplateData }) => {
  const { templateId } = useParams();
  const [isSaving, setIsSaving] = useState(false);

  const { isDirty, markClean } = useDirtyChecker(templateData);

  const handleChange = (e) => {
    setTemplateData({ ...templateData, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    try {
      setIsSaving(true);
      const payload = {
        ...templateData,
        name: file.name // ensure consistency
      };
      const { message } = await axiosInstance.patch(`/googledoc/${file.id}`, payload);
      toastSuccess(message || "Google Doc Template saved.");
      markClean();
    } catch (err) {
      handleApiError(err);
    } finally {
      setIsSaving(false);
    }
  };
  const handleUpload = async (e) => {
    const uploadedFile = e.target.files[0];
    const fileName = uploadedFile?.name;
    const regex = /^[a-zA-Z0-9 _.-]+$/;

    if (!regex.test(fileName)) {
      toastError("Special characters not allowed in file name");
      return;
    }

    const formData = new FormData();
    formData.append("myFile", uploadedFile);
    formData.append("name", templateData.template_name);
    formData.append("id", templateId);

    try {
      const { data, message } = await axiosInstance.post(`/googledoc-template`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      setTemplateData((prev) => ({
        ...prev,
        template_id: data.template_id
      }));

      toastSuccess(message);
    } catch (err) {
      handleApiError(err);
    }
  };

  const handleDownload = async () => {
    try {
      const response = await axiosInstance.get(`/template-file/${templateData.template_id}`, {
        responseType: "blob"
      });
      saveFile(response, templateData.template_id);
    } catch (err) {
      handleApiError(err);
    }
  };

  return (
    <div className="d_flex flex_column">
      <GenericActionBar
        path={
          <div>
            <em>Google Doc Templates</em> → <span>{file.name}</span>
          </div>
        }
        actions={[
          {
            key: "save",
            icon: "save",
            title: isSaving ? "Saving..." : "Save",
            onClick: isSaving ? undefined : handleSave
          }
        ]}
        options={{
          save: {
            className: `${isDirty ? "save_glowing" : ""} ${isSaving ? "disabled" : ""}`.trim()
          }
        }}
      />

      <div className="template_form_outer builder_form">
        <Input label="Template Name" name="template_name" value={templateData.template_name} onChange={handleChange} />

        <div>
          <div className="d_flex justify_between mb_2">
            <div className="d_flex gap_2 align_center">
              <label className="builder_label">Select File</label>
              <label style={{ fontWeight: "700" }}>{templateData.template_id || "Template not added yet"}</label>
            </div>
            {templateData.template_id && <MaterialIcon name="download" onClick={handleDownload} />}
          </div>
          <Input type="file" onChange={handleUpload} />
        </div>

        <Textarea label="Body" name="body" value={templateData.body} onChange={handleChange} />
      </div>
    </div>
  );
};

export default GoogleDocTemplateEditor;
